import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@upr-web-primer/dal';
import { DalModule } from '@upr-web-primer/dal';
import { DigitalDataModule } from '@upr-web-primer/digital-data';
import { HttpHeaders } from '@angular/common/http';
import * as i3 from '@upr-web-primer/app-utils';
import * as i2 from '@upr-web-primer/locale';
import { isEmpty, isArray } from 'lodash-es';
class MsPersonalizationService {
  constructor(dal, localeService, appEnvService, appDefaults, relativeUrls) {
    this.dal = dal;
    this.localeService = localeService;
    this.appEnvService = appEnvService;
    this.appDefaults = appDefaults;
    this.relativeUrls = relativeUrls;
    this.envConfigAppEnv = this.appEnvService.getEnvVariables('app_env');
    if (!isEmpty(this.envConfigAppEnv.content_id)) {
      this.loadEnvValues(this.envConfigAppEnv.content_id);
    }
  }
  /**
   * @public method to get content from content ids
   * @returns content
   **/
  getContent(contentIds) {
    let listOfContentId;
    const locale = this.localeService.getFromStorage();
    const language = locale?.language;
    const country = locale?.country?.toUpperCase();
    const httpOptions = new HttpHeaders({
      'Accept-Language': `${language}-${country}` + (language === 'es' ? ',en-US' : '')
    });
    if (isArray(contentIds)) {
      listOfContentId = contentIds.filter(contentId => contentId !== undefined);
      listOfContentId = listOfContentId.join(',');
    } else {
      listOfContentId = contentIds;
    }
    const relativeUrl = this.replaceCode(this.relativeUrls.FETCH_CONTENT) + listOfContentId;
    return this.dal.httpRequest(relativeUrl, 'GET', {}, httpOptions);
  }
  /**
   * Load Env Values from Tridion, and apply directly to app env service.
   * @param {string | string[]} content_id Same as getContent content_id
   **/
  loadEnvValues(content_id) {
    this.getContent(content_id).then(json => this.appEnvService.mergeWithCurrentEnv(json));
  }
  /**
   * @private method to replace the code in the url
   * @param url
   * @returns string by replacing {resortAreaCode}
   **/
  replaceCode(url) {
    return url ? url.replace('{resortAreaCode}', this.appDefaults.PERSONALIZE_RESORT_CODE) : '';
  }
  static {
    this.ɵfac = function MsPersonalizationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MsPersonalizationService)(i0.ɵɵinject(i1.DalService), i0.ɵɵinject(i2.LocaleService), i0.ɵɵinject(i3.AppEnvironmentService), i0.ɵɵinject('AppDefaults'), i0.ɵɵinject('RelativeUrls'));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MsPersonalizationService,
      factory: MsPersonalizationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MsPersonalizationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DalService
  }, {
    type: i2.LocaleService
  }, {
    type: i3.AppEnvironmentService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['AppDefaults']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['RelativeUrls']
    }]
  }], null);
})();
class MsPersonalizationModule {
  static {
    this.ɵfac = function MsPersonalizationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MsPersonalizationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MsPersonalizationModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [MsPersonalizationService],
      imports: [DigitalDataModule, DalModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MsPersonalizationModule, [{
    type: NgModule,
    args: [{
      imports: [DigitalDataModule, DalModule],
      providers: [MsPersonalizationService]
    }]
  }], null, null);
})();

/*
 * Public API Surface of ms-personalization
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MsPersonalizationModule, MsPersonalizationService };
